import {Controller} from "@hotwired/stimulus"
import TomSelect from "tom-select";
import {get} from "@rails/request.js";

// Connects to data-controller="tom-select--select"
export default class extends Controller {
  static values =
    {
      url: String,
      create: {
        type: Boolean,
        default: false
      },
      removeButton: { type: Boolean, default: true },
      plugins: {
        type: Array,
        default: ['remove_button', 'change_listener']
      },
      lock: {
        type: Boolean,
        default: false
      },
      customRenderer: {
        type: Boolean,
        default: false
      },
      options: {
        type: Array,
        default: []
      }
    }

  connect() {
    const plugins = this.pluginsValue.filter(plugin => {
      return !(plugin === 'remove_button' && !this.removeButtonValue);
    });
    let config = {
      plugins: plugins,
      valueField: 'id',
      selectOnTab: true,
      closeAfterSelect: true,
      create: this.createValue,
      createOnBlur: this.createValue,
      preload: 'focus',
      ...(this.customRendererValue === true  ? {     options: this.optionsValue,
        searchField: ['name','subtitle'],
        render: {
          option: function(data, escape) {
            return '<div>' +
              '<div class="text-body-secondary fs-6 fw-semibold">' + escape(data.name) + '</div>' +
              '<div class="text-body-secondary">' + escape(data.subtitle) + '</div>' +
              '</div>';
          },
          item: function(data, escape) {
            return '<div title="' + escape(data.subtitle) + '">' + escape(data.name) + '</div>';
          }
        } } : {} ),
    }
    this.tomSelect = new TomSelect(this.element, config)

    if (this.lockValue) {
      this.tomSelect.lock()
    }

    if (this.hasUrlValue) {
      this.fetchItems()
    }
  }


  disconnect() {
    this.tomSelect.destroy()
  }

  async fetchItems() {
    const response = await get(this.urlValue, {
      responseKind: 'json'
    })

    if (response.ok)
      this.setItems(await response.json)
    else
      console.log(response)
  }

  setItems(items) {
    this.tomSelect.addOptions(items)
  }
}
